import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    "⚠️  Missing Supabase environment variables.\n" +
    "Make sure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY\n" +
    "are set in your .env.local file."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
